import React, { useState, useCallback, memo, useEffect } from 'react';
import { useFamily } from '../../../context/FamilyContext';
import './TopSectionContainer.css';
import AvatarDisplay from './AvatarDisplay';
import AllowanceInfo from './AllowanceInfo';
import MyButton from '../../basic/MyButton';
import ModalEditAllowance from './modalEditAllowance';
import ManageWeeklyExpensesModal from './ManageWeeklyExpensesModal'; // We'll create this next

const TopSectionContainer = memo(function TopSectionContainer({ selectedChild, notifySuccess }) {
const [refreshKey, setRefreshKey] = useState(0);
const [isAllowanceModalOpen, setAllowanceModalOpen] = useState(false);
const [isExpensesModalOpen, setExpensesModalOpen] = useState(false);

    useEffect(() => {
        console.log("TopSectionContainer - selectedChild:", selectedChild);
    }, [selectedChild]);

    const handleOpenAllowanceModal = useCallback(() => {
        console.log('Allowance modal opening');
        setAllowanceModalOpen(true);
    }, []);

    const handleCloseAllowanceModal = useCallback(() => {
        setAllowanceModalOpen(false);
    }, []);

    const handleOpenExpensesModal = useCallback(() => {
        console.log('Expenses modal opening');
        setExpensesModalOpen(true);
    }, []);

    const handleCloseExpensesModal = useCallback(() => {
        setExpensesModalOpen(false);
    }, []);

    const handleAllowanceUpdateSuccess = useCallback((message) => {
        setRefreshKey(prevKey => prevKey + 1);
        notifySuccess(message);
        handleCloseAllowanceModal();
    }, [notifySuccess, handleCloseAllowanceModal]);

    const handleExpensesUpdateSuccess = useCallback((message) => {
        setRefreshKey(prevKey => prevKey + 1);
        notifySuccess(message);
        handleCloseExpensesModal();
    }, [notifySuccess, handleCloseExpensesModal]);

    if (!selectedChild) return null;

    return (
        <div className="top-section-container-wrapper">
            <div className="top-section-container">
                <AvatarDisplay 
                    imageUrl={selectedChild.avatarUrl} 
                    childName={selectedChild.display_name} 
                    childId={selectedChild.childId} 
                />
                <AllowanceInfo 
                    childId={selectedChild.childId} 
                    refreshTrigger={refreshKey}
                />
                <div className="edit-buttons">
                    <MyButton text="Allowance" onClick={handleOpenAllowanceModal} />
                    <MyButton 
                        text="Weekly Expenses" 
                        onClick={handleOpenExpensesModal}
                        style={{ marginLeft: '10px' }} 
                    />
                </div>
                <ModalEditAllowance
                    isOpen={isAllowanceModalOpen}
                    onClose={handleCloseAllowanceModal}
                    childId={selectedChild.childId}
                    onSaveSuccess={handleAllowanceUpdateSuccess}
                    notifySuccess={notifySuccess}
                />
                <ManageWeeklyExpensesModal 
                    isOpen={isExpensesModalOpen}
                    onClose={handleCloseExpensesModal}
                    childId={selectedChild.childId}
                    onSaveSuccess={handleExpensesUpdateSuccess}
                />
            </div>
        </div>
    );
});

export default TopSectionContainer;